import { PresetTag } from '@components/display';
import { TSegmentDefType } from '@definitions/states';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { CSSProperties, FC } from 'react';
import { IAvailableIcons } from 'common-components';

type StateTagSegmentPropsType = {
  state: TSegmentDefType
  style?: CSSProperties
};

const StateTagSegment: FC<StateTagSegmentPropsType> = ({ state, style }) => {
  const { translate } = useAppTranslation();

  const getTagIcon = (state: TSegmentDefType): IAvailableIcons => {
    switch (state) {
      case 10:
        return 'Hand';
      case 20:
        return 'Star06';
      case 30:
        return 'CheckVerified01';
      case 40:
        return 'UserCircle';
      default:
        return 'Plus';
    }
  };

  return (
    <PresetTag preset="segment-type" state={state} icon={getTagIcon(state)} style={style}>
      {translate(`common.states.segmentState.${state}`)}
    </PresetTag>
  );
};

export default StateTagSegment;
